// // // import React, { useState, useEffect } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // // Shipment and payment modes
// // // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // // type PaymentMode = "paid" | "to_pay" | "credit";
// // // type FilterOption = "all" | ShipmentStatus;

// // // const API_BASE = process.env.REACT_APP_API_URL;

// // // // APIConsignment interface according to the API response sample
// // // interface APIConsignment {
// // //   id: number;
// // //   sender: number; // Consignor id
// // //   company: number;
// // //   receiver: number; // Consignee id
// // //   transporter: number;
// // //   driver: number;
// // //   vehicles: number;
// // //   payment: string;
// // //   source: string;
// // //   destination: string;
// // //   receiverAmountStatatus: string; // intentional typo, matches API
// // //   senderAmountStatatus: string;
// // //   transporterAmountStatatus: string;
// // //   paymentStatus: PaymentMode;
// // //   paymentPayableConsignor: number;
// // //   ItemsDescription: string;
// // //   ["InvoiceNo"]?: string;
// // //   ["InvoiceNo."]?: string;
// // //   EWAYBILLNO: string;
// // //   subjects: string;
// // //   link?: string;
// // //   status?: ShipmentStatus; // Not present in sample, but kept for filtering fallback
// // //   biltyNo?: string;    // Custom field - fallback to InvoiceNo if not exists
// // //   truckNo?: string;    // Custom field for truck number/vehicle number
// // //   created_at?: string;       // Custom field for date -- fallback to created_at if not exists
// // //   weight?: number;     // Custom field for weight
// // //   biltyRate?: number;  // Custom field for bilty rate
// // //   totalamount?: number;     // Total amount
// // //   // The following fields are mostly placeholders - map from data if available
// // //   consignorName?: string;
// // //   consigneeName?: string;
// // // }

// // // const getInvoiceNo = (consignment: APIConsignment): string =>
// // //   consignment.InvoiceNo ||
// // //   //@ts-ignore
// // //   consignment["InvoiceNo."] ||
// // //   "";

// // // const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
// // //   if (consignment.status) return consignment.status;
// // //   if (consignment.paymentStatus === "to_pay" || consignment.paymentStatus === "credit") return "pending";
// // //   if (consignment.paymentStatus === "paid") return "delivered";
// // //   return "pending";
// // // };

// // // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// // //   { key: "all",       label: "All"        },
// // //   { key: "pending",   label: "Pending"    },
// // //   { key: "in_transit",label: "In transit" },
// // //   { key: "delivered", label: "Delivered"  },
// // //   { key: "draft",     label: "Draft"      },
// // // ];

// // // const STATUS_STYLES: Record<string, string> = {
// // //   pending:    "bg-amber-100 text-amber-800",
// // //   in_transit: "bg-blue-100 text-blue-800",
// // //   delivered:  "bg-green-100 text-green-800",
// // //   draft:      "bg-slate-100 text-slate-500",
// // //   created:    "bg-slate-100 text-slate-900",
// // //   dispatched: "bg-amber-100 text-amber-800",
// // //   cancelled:  "bg-red-100 text-red-800",
// // // };

// // // const STATUS_LABELS: Record<string, string> = {
// // //   pending:    "Pending",
// // //   in_transit: "In transit",
// // //   delivered:  "Delivered",
// // //   draft:      "Draft",
// // //   created:    "Created",
// // //   dispatched: "Dispatched",
// // //   cancelled:  "Cancelled",
// // // };

// // // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// // //   <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[status] || "bg-slate-100 text-slate-900"}`}>
// // //     {STATUS_LABELS[status] || status}
// // //   </span>
// // // );

// // // const DashboardStatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
// // //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// // //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>{value}</span>
// // //     <span className="text-xs font-medium text-slate-500">{label}</span>
// // //   </div>
// // // );

// // // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({ consignment }) => {
// // //   const link = consignment.link;
// // //   const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// // //   const getDownloadUrl = () => {
// // //     if (!link) return "";
// // //     if (link.startsWith("http")) return link;
// // //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// // //     return link;
// // //   };

// // //   const downloadUrl = getDownloadUrl();

// // //   const handleView = () => {
// // //     if (downloadUrl) window.open(downloadUrl, "_blank");
// // //   };
// // //   const handleDownload = () => {
// // //     if (downloadUrl) {
// // //       const a = document.createElement("a");
// // //       a.href = downloadUrl;
// // //       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// // //       document.body.appendChild(a);
// // //       a.click();
// // //       document.body.removeChild(a);
// // //     }
// // //   };
// // //   const handleShare = () => {
// // //     if (navigator.share && downloadUrl) {
// // //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// // //     } else if (downloadUrl) {
// // //       navigator.clipboard.writeText(downloadUrl);
// // //       alert("Invoice link copied!");
// // //     }
// // //   };
// // //   if (!link) {
// // //     return <span className="text-slate-400">No invoice</span>;
// // //   }
// // //   return (
// // //     <div className="flex items-center gap-2">
// // //       <button className="hover:bg-slate-100 rounded p-1" title="View Invoice" onClick={handleView}>
// // //         <FiEye className="w-4 h-4 text-blue-700" />
// // //       </button>
// // //       <button className="hover:bg-slate-100 rounded p-1" title="Download Invoice" onClick={handleDownload}>
// // //         <FiDownload className="w-4 h-4 text-green-700" />
// // //       </button>
// // //       <button className="hover:bg-slate-100 rounded p-1" title="Share Invoice" onClick={handleShare}>
// // //         <FiShare2 className="w-4 h-4 text-purple-600" />
// // //       </button>
// // //     </div>
// // //   );
// // // };

// // // const RowActions: React.FC<{
// // //   consignment: APIConsignment;
// // //   onEdit: (id: number) => void;
// // //   onDelete: (id: number) => void;
// // // }> = ({ consignment, onEdit, onDelete }) => (
// // //   <div className="flex items-center gap-2">
// // //     <button className="hover:bg-slate-100 rounded p-1" title="Edit" onClick={() => onEdit(consignment.id)}>
// // //       <FiEdit className="w-4 h-4 text-amber-600" />
// // //     </button>
// // //     <button className="hover:bg-slate-100 rounded p-1" title="Delete" onClick={() => onDelete(consignment.id)}>
// // //       <FiTrash className="w-4 h-4 text-red-700" />
// // //     </button>
// // //   </div>
// // // );

// // // // Optional: Fake lists for Consignor/Consignee/Truck - in real app, fetch those and map by id
// // // const FAKE_CONSIGNOR = (id: number) => `Consignor#${id}`;
// // // const FAKE_CONSIGNEE = (id: number) => `Consignee#${id}`;
// // // const FAKE_TRUCK = (id: number) => `Truck#${id}`;

// // // const ConsignorDashboard: React.FC = () => {
// // //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState<string | null>(null);
// // //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// // //   const navigate = useNavigate();

// // //   useEffect(() => {
// // //     setLoading(true);
// // //     setError(null);
// // //     fetch(`${API_BASE}/invoiceapi/invoice`)
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (Array.isArray(data)) {
// // //           setConsignments(
// // //             data.map((c: any) => {
// // //               let invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// // //               // Pull date, truck number, weight, bilty rate, amount from API if available
// // //               // This is an example; you should map the right fields per your real API structure
// // //               return {
// // //                 id: c.id,
// // //                 sender: c.sender,
// // //                 company: c.company,
// // //                 receiver: c.receiver,
// // //                 transporter: c.transporter,
// // //                 driver: c.driver,
// // //                 vehicles: c.vehicles,
// // //                 payment: c.payment,
// // //                 source: c.source,
// // //                 destination: c.destination,
// // //                 receiverAmountStatatus: c.receiverAmountStatatus,
// // //                 senderAmountStatatus: c.senderAmountStatatus,
// // //                 transporterAmountStatatus: c.transporterAmountStatatus,
// // //                 paymentStatus: c.paymentStatus,
// // //                 paymentPayableConsignor: c.paymentPayableConsignor,
// // //                 ItemsDescription: c.ItemsDescription,
// // //                 InvoiceNo: invoiceNo,
// // //                 "InvoiceNo.": c["InvoiceNo."],
// // //                 EWAYBILLNO: c.EWAYBILLNO,
// // //                 subjects: c.subjects,
// // //                 link: c.link ?? c.invoiceLink,
// // //                 status: c.status ?? undefined,
// // //                 biltyNo: c.biltyNo ?? invoiceNo,
// // //                 truckNo: c.truckNo ?? c.vehicles ?? "",
// // //                 date: c.date ?? c.created_at ?? "",
// // //                 weight: c.weight ?? "",
// // //                 biltyRate: c.biltyRate ?? "",
// // //                 amount: c.amount ?? c.paymentPayableConsignor ?? c.payment ?? "",
// // //                 consignorName: c.consignorName || (c.sender ? FAKE_CONSIGNOR(c.sender) : ""),
// // //                 consigneeName: c.consigneeName || (c.receiver ? FAKE_CONSIGNEE(c.receiver) : ""),
// // //               };
// // //             })
// // //           );
// // //         } else {
// // //           setConsignments([]);
// // //         }
// // //       })
// // //       .catch(() => setError("Unable to fetch consignments"))
// // //       .finally(() => setLoading(false));
// // //   }, []);

// // //   const filtered = activeFilter === "all"
// // //     ? consignments
// // //     : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

// // //   const handleEdit = (id: number) => navigate(`/consignor/consignments/edit/${id}`);

// // //   const handleDelete = (id: number) => {
// // //     if (
// // //       !window.confirm("Are you sure you want to delete this consignment? This action cannot be undone.")
// // //     ) return;
// // //     setConsignments(prev => prev.filter(c => c.id !== id));
// // //   };

// // //   const stats = [
// // //     {
// // //       label: "Total",
// // //       value: consignments.length,
// // //       color: "#185FA5"
// // //     },
// // //     {
// // //       label: "Pending",
// // //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending").length,
// // //       color: "#854F0B"
// // //     },
// // //     {
// // //       label: "In transit",
// // //       value: consignments.filter((c) => getConsignmentStatus(c) === "in_transit").length,
// // //       color: "#534AB7"
// // //     },
// // //     {
// // //       label: "Delivered",
// // //       value: consignments.filter((c) => getConsignmentStatus(c) === "delivered").length,
// // //       color: "#3B6D11"
// // //     }
// // //   ];

// // //   return (
// // //     <div className="p-4 md:p-6 space-y-4">
// // //       {/* Stats */}
// // //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// // //         {stats.map(stat => (
// // //           <DashboardStatCard key={stat.label} {...stat} />
// // //         ))}
// // //       </div>
// // //       {/* Panel/Table */}
// // //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// // //         <div className="flex items-center justify-between mb-3">
// // //           <div>
// // //             <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
// // //             <p className="text-xs text-slate-400">View and manage your consignments & invoices</p>
// // //           </div>
// // //           <button
// // //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// // //             onClick={() => navigate("/consignor/consignments/create")}
// // //           >
// // //             + New Consignment
// // //           </button>
// // //         </div>
// // //         <div className="flex flex-wrap gap-1.5 mb-4">
// // //           {FILTER_OPTIONS.map(({ key, label }) => (
// // //             <button
// // //               key={key}
// // //               onClick={() => setActiveFilter(key)}
// // //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// // //                 activeFilter === key
// // //                   ? "bg-slate-900 text-white border-transparent"
// // //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// // //               }`}
// // //             >
// // //               {label}
// // //             </button>
// // //           ))}
// // //         </div>
// // //         <div className="overflow-x-auto">
// // //           <table className="w-full min-w-[1200px] text-[13px]">
// // //             <thead>
// // //               <tr className="text-xs border-b border-slate-100">
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Date</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Bilty No.</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Truck No.</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Consignor</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Consignee</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Weight</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Bilty Rate</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Amount</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap"></th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Status</th>
// // //                 <th className="py-2 px-3 font-semibold text-slate-500 text-nowrap">Invoice</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {loading ? (
// // //                 <tr><td colSpan={11} className="py-6 text-center">Loading...</td></tr>
// // //               ) : error ? (
// // //                 <tr><td colSpan={11} className="py-6 text-center text-red-600">{error}</td></tr>
// // //               ) : filtered.length === 0 ? (
// // //                 <tr><td colSpan={11} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
// // //               ) : (
// // //                 filtered.map((c) => (
// // //                   <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50 transition-all">
// // //                     <td className="py-2 px-3 text-slate-900">{c.created_at ? new Date(c.created_at).toLocaleDateString() : "-"}</td>
// // //                     <td className="py-2 px-3 text-slate-900 font-medium">{c.biltyNo || getInvoiceNo(c) || "-"}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.truckNo || FAKE_TRUCK(c.vehicles) || "-"}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.consignorName || (c.sender ? FAKE_CONSIGNOR(c.sender) : "-")}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.consigneeName || (c.receiver ? FAKE_CONSIGNEE(c.receiver) : "-")}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.weight ? c.weight : "-"}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.biltyRate ? c.biltyRate : "-"}</td>
// // //                     <td className="py-2 px-3 text-slate-700">{c.totalamount ? c.totalamount : c.payment || "-"}</td>
// // //                     <td className="py-2 px-3 text-right">
// // //                       <RowActions
// // //                         consignment={c}
// // //                         onEdit={handleEdit}
// // //                         onDelete={handleDelete}
// // //                       />
// // //                     </td>
// // //                     <td className="py-2 px-3"><StatusBadge status={getConsignmentStatus(c)} /></td>
// // //                     <td className="py-2 px-3"><InvoiceActions consignment={c} /></td>
// // //                   </tr>
// // //                 ))
// // //               )}
// // //             </tbody>
// // //           </table>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default ConsignorDashboard;


// // import React, { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// // // Shipment and payment modes
// // type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// // type PaymentMode = "paid" | "to_pay" | "credit";
// // type FilterOption = "all" | ShipmentStatus;

// // const API_BASE = process.env.REACT_APP_API_URL;

// // // APIConsignment interface according to the API response sample
// // interface APIConsignment {
// //   id: number;
// //   sender: number;
// //   company: number;
// //   receiver: number;
// //   transporter: number;
// //   driver: number;
// //   vehicles: number;
// //   payment: string;
// //   source: string;
// //   destination: string;
// //   receiverAmountStatatus: string;
// //   senderAmountStatatus: string;
// //   transporterAmountStatatus: string;
// //   paymentStatus: PaymentMode;
// //   paymentPayableConsignor: number;
// //   ItemsDescription: string;
// //   ["InvoiceNo"]?: string;
// //   ["InvoiceNo."]?: string;
// //   EWAYBILLNO: string;
// //   subjects: string;
// //   link?: string;
// //   status?: ShipmentStatus;
// //   biltyNo?: string;
// //   truckNo?: string;
// //   created_at?: string;
// //   weight?: number;
// //   biltyRate?: number;
// //   totalamount?: number;
// //   consignorName?: string;
// //   consigneeName?: string;
// // }

// // const getInvoiceNo = (consignment: APIConsignment): string =>
// //   consignment.InvoiceNo ||
// //   //@ts-ignore
// //   consignment["InvoiceNo."] ||
// //   "";

// // const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
// //   if (consignment.status) return consignment.status;
// //   if (
// //     consignment.paymentStatus === "to_pay" ||
// //     consignment.paymentStatus === "credit"
// //   )
// //     return "pending";
// //   if (consignment.paymentStatus === "paid") return "delivered";
// //   return "pending";
// // };

// // const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
// //   { key: "all", label: "All" },
// //   { key: "pending", label: "Pending" },
// //   { key: "in_transit", label: "In transit" },
// //   { key: "delivered", label: "Delivered" },
// //   { key: "draft", label: "Draft" },
// // ];

// // const STATUS_STYLES: Record<string, string> = {
// //   pending: "bg-amber-100 text-amber-800",
// //   in_transit: "bg-blue-100 text-blue-800",
// //   delivered: "bg-green-100 text-green-800",
// //   draft: "bg-slate-100 text-slate-500",
// //   created: "bg-slate-100 text-slate-900",
// //   dispatched: "bg-amber-100 text-amber-800",
// //   cancelled: "bg-red-100 text-red-800",
// // };

// // const STATUS_LABELS: Record<string, string> = {
// //   pending: "Pending",
// //   in_transit: "In transit",
// //   delivered: "Delivered",
// //   draft: "Draft",
// //   created: "Created",
// //   dispatched: "Dispatched",
// //   cancelled: "Cancelled",
// // };

// // const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
// //   <span
// //     className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
// //       STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
// //     }`}
// //   >
// //     {STATUS_LABELS[status] || status}
// //   </span>
// // );

// // const DashboardStatCard: React.FC<{
// //   label: string;
// //   value: number;
// //   color: string;
// // }> = ({ label, value, color }) => (
// //   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
// //     <span className="text-[26px] font-semibold mb-1" style={{ color }}>
// //       {value}
// //     </span>
// //     <span className="text-xs font-medium text-slate-500">{label}</span>
// //   </div>
// // );

// // const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({
// //   consignment,
// // }) => {
// //   const link = consignment.link;
// //   const invoiceLabel =
// //     getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

// //   const getDownloadUrl = () => {
// //     if (!link) return "";
// //     if (link.startsWith("http")) return link;
// //     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
// //     return link;
// //   };

// //   const downloadUrl = getDownloadUrl();

// //   const handleView = () => {
// //     if (downloadUrl) window.open(downloadUrl, "_blank");
// //   };

// //   const handleDownload = () => {
// //     if (downloadUrl) {
// //       const a = document.createElement("a");
// //       a.href = downloadUrl;
// //       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
// //       document.body.appendChild(a);
// //       a.click();
// //       document.body.removeChild(a);
// //     }
// //   };

// //   const handleShare = () => {
// //     if (navigator.share && downloadUrl) {
// //       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
// //     } else if (downloadUrl) {
// //       navigator.clipboard.writeText(downloadUrl);
// //       alert("Invoice link copied!");
// //     }
// //   };

// //   if (!link) {
// //     return <span className="text-slate-400 text-xs">No invoice</span>;
// //   }

// //   return (
// //     <div className="flex items-center gap-2">
// //       <button
// //         className="hover:bg-slate-100 rounded p-1"
// //         title="View Invoice"
// //         onClick={handleView}
// //       >
// //         <FiEye className="w-4 h-4 text-blue-700" />
// //       </button>
// //       <button
// //         className="hover:bg-slate-100 rounded p-1"
// //         title="Download Invoice"
// //         onClick={handleDownload}
// //       >
// //         <FiDownload className="w-4 h-4 text-green-700" />
// //       </button>
// //       <button
// //         className="hover:bg-slate-100 rounded p-1"
// //         title="Share Invoice"
// //         onClick={handleShare}
// //       >
// //         <FiShare2 className="w-4 h-4 text-purple-600" />
// //       </button>
// //     </div>
// //   );
// // };

// // const RowActions: React.FC<{
// //   consignment: APIConsignment;
// //   onEdit: (id: number) => void;
// //   onDelete: (id: number) => void;
// // }> = ({ consignment, onEdit, onDelete }) => (
// //   <div className="flex items-center gap-2">
// //     <button
// //       className="hover:bg-slate-100 rounded p-1"
// //       title="Edit"
// //       onClick={() => onEdit(consignment.id)}
// //     >
// //       <FiEdit className="w-4 h-4 text-amber-600" />
// //     </button>
// //     <button
// //       className="hover:bg-slate-100 rounded p-1"
// //       title="Delete"
// //       onClick={() => onDelete(consignment.id)}
// //     >
// //       <FiTrash className="w-4 h-4 text-red-700" />
// //     </button>
// //   </div>
// // );

// // const FAKE_CONSIGNOR = (id: number) => `Consignor#${id}`;
// // const FAKE_CONSIGNEE = (id: number) => `Consignee#${id}`;
// // const FAKE_TRUCK = (id: number) => `Truck#${id}`;

// // const ConsignorDashboard: React.FC = () => {
// //   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState<string | null>(null);
// //   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     setLoading(true);
// //     setError(null);
// //     fetch(`${API_BASE}/invoiceapi/invoice`)
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (Array.isArray(data)) {
// //           setConsignments(
// //             data.map((c: any) => {
// //               let invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
// //               return {
// //                 id: c.id,
// //                 sender: c.sender,
// //                 company: c.company,
// //                 receiver: c.receiver,
// //                 transporter: c.transporter,
// //                 driver: c.driver,
// //                 vehicles: c.vehicles,
// //                 payment: c.payment,
// //                 source: c.source,
// //                 destination: c.destination,
// //                 receiverAmountStatatus: c.receiverAmountStatatus,
// //                 senderAmountStatatus: c.senderAmountStatatus,
// //                 transporterAmountStatatus: c.transporterAmountStatatus,
// //                 paymentStatus: c.paymentStatus,
// //                 paymentPayableConsignor: c.paymentPayableConsignor,
// //                 ItemsDescription: c.ItemsDescription,
// //                 InvoiceNo: invoiceNo,
// //                 "InvoiceNo.": c["InvoiceNo."],
// //                 EWAYBILLNO: c.EWAYBILLNO,
// //                 subjects: c.subjects,
// //                 link: c.link ?? c.invoiceLink,
// //                 status: c.status ?? undefined,
// //                 biltyNo: c.biltyNo ?? invoiceNo,
// //                 truckNo: c.truckNo ?? c.vehicles ?? "",
// //                 created_at: c.created_at ?? "",
// //                 weight: c.weight ?? null,
// //                 biltyRate: c.biltyRate ?? null,
// //                 totalamount: c.totalamount ?? c.paymentPayableConsignor ?? null,
// //                 consignorName:
// //                   c.consignorName ||
// //                   (c.sender ? FAKE_CONSIGNOR(c.sender) : ""),
// //                 consigneeName:
// //                   c.consigneeName ||
// //                   (c.receiver ? FAKE_CONSIGNEE(c.receiver) : ""),
// //               };
// //             })
// //           );
// //         } else {
// //           setConsignments([]);
// //         }
// //       })
// //       .catch(() => setError("Unable to fetch consignments"))
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const filtered =
// //     activeFilter === "all"
// //       ? consignments
// //       : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

// //   const handleEdit = (id: number) =>
// //     navigate(`/consignor/consignments/edit/${id}`);

// //   const handleDelete = (id: number) => {
// //     if (
// //       !window.confirm(
// //         "Are you sure you want to delete this consignment? This action cannot be undone."
// //       )
// //     )
// //       return;
// //     setConsignments((prev) => prev.filter((c) => c.id !== id));
// //   };

// //   const stats = [
// //     {
// //       label: "Total",
// //       value: consignments.length,
// //       color: "#185FA5",
// //     },
// //     {
// //       label: "Pending",
// //       value: consignments.filter((c) => getConsignmentStatus(c) === "pending")
// //         .length,
// //       color: "#854F0B",
// //     },
// //     {
// //       label: "In transit",
// //       value: consignments.filter(
// //         (c) => getConsignmentStatus(c) === "in_transit"
// //       ).length,
// //       color: "#534AB7",
// //     },
// //     {
// //       label: "Delivered",
// //       value: consignments.filter(
// //         (c) => getConsignmentStatus(c) === "delivered"
// //       ).length,
// //       color: "#3B6D11",
// //     },
// //   ];

// //   return (
// //     <div className="p-4 md:p-6 space-y-4">
// //       {/* Stats */}
// //       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
// //         {stats.map((stat) => (
// //           <DashboardStatCard key={stat.label} {...stat} />
// //         ))}
// //       </div>

// //       {/* Panel / Table */}
// //       <div className="bg-white border border-slate-100 rounded-2xl p-4">
// //         {/* Header */}
// //         <div className="flex items-center justify-between mb-3">
// //           <div>
// //             <h2 className="text-[16px] font-medium text-slate-900">
// //               My Consignments
// //             </h2>
// //             <p className="text-xs text-slate-400">
// //               View and manage your consignments &amp; invoices
// //             </p>
// //           </div>
// //           <button
// //             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
// //             onClick={() => navigate("/consignor/consignments/create")}
// //           >
// //             + New Consignment
// //           </button>
// //         </div>

// //         {/* Filter Pills */}
// //         <div className="flex flex-wrap gap-1.5 mb-4">
// //           {FILTER_OPTIONS.map(({ key, label }) => (
// //             <button
// //               key={key}
// //               onClick={() => setActiveFilter(key)}
// //               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
// //                 activeFilter === key
// //                   ? "bg-slate-900 text-white border-transparent"
// //                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
// //               }`}
// //             >
// //               {label}
// //             </button>
// //           ))}
// //         </div>

// //         {/* Table */}
// //         <div className="overflow-x-auto">
// //           <table className="w-full min-w-[1100px] text-[13px]">
// //             <thead>
// //               <tr className="text-xs border-b border-slate-100">
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Date
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Bilty No.
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Truck No.
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Consignor
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Consignee
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Weight
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Bilty Rate
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Amount
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Status
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Invoice
// //                 </th>
// //                 <th className="py-2 px-3 font-semibold text-slate-500 text-left text-nowrap">
// //                   Actions
// //                 </th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {loading ? (
// //                 <tr>
// //                   <td colSpan={11} className="py-6 text-center text-slate-400">
// //                     Loading...
// //                   </td>
// //                 </tr>
// //               ) : error ? (
// //                 <tr>
// //                   <td colSpan={11} className="py-6 text-center text-red-600">
// //                     {error}
// //                   </td>
// //                 </tr>
// //               ) : filtered.length === 0 ? (
// //                 <tr>
// //                   <td colSpan={11} className="py-8 text-center text-slate-400">
// //                     No consignments found.
// //                   </td>
// //                 </tr>
// //               ) : (
// //                 filtered.map((c) => (
// //                   <tr
// //                     key={c.id}
// //                     className="border-b border-slate-100 hover:bg-slate-50 transition-all"
// //                   >
// //                     {/* Date */}
// //                     <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
// //                       {c.created_at
// //                         ? new Date(c.created_at).toLocaleDateString()
// //                         : "-"}
// //                     </td>

// //                     {/* Bilty No. */}
// //                     <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
// //                       {c.biltyNo || getInvoiceNo(c) || "-"}
// //                     </td>

// //                     {/* Truck No. */}
// //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// //                       {c.truckNo
// //                         ? c.truckNo
// //                         : c.vehicles
// //                         ? FAKE_TRUCK(c.vehicles)
// //                         : "-"}
// //                     </td>

// //                     {/* Consignor */}
// //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// //                       {c.consignorName ||
// //                         (c.sender ? FAKE_CONSIGNOR(c.sender) : "-")}
// //                     </td>

// //                     {/* Consignee */}
// //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// //                       {c.consigneeName ||
// //                         (c.receiver ? FAKE_CONSIGNEE(c.receiver) : "-")}
// //                     </td>

// //                     {/* Weight */}
// //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// //                       {c.weight != null ? c.weight : "-"}
// //                     </td>

// //                     {/* Bilty Rate */}
// //                     <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
// //                       {c.biltyRate != null ? c.biltyRate : "-"}
// //                     </td>

// //                     {/* Amount */}
// //                     <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
// //                       {c.totalamount != null
// //                         ? c.totalamount
// //                         : c.payment || "-"}
// //                     </td>

// //                     {/* Status */}
// //                     <td className="py-2 px-3 whitespace-nowrap">
// //                       <StatusBadge status={getConsignmentStatus(c)} />
// //                     </td>

// //                     {/* Invoice */}
// //                     <td className="py-2 px-3 whitespace-nowrap">
// //                       <InvoiceActions consignment={c} />
// //                     </td>

// //                     {/* Actions */}
// //                     <td className="py-2 px-3 whitespace-nowrap">
// //                       <RowActions
// //                         consignment={c}
// //                         onEdit={handleEdit}
// //                         onDelete={handleDelete}
// //                       />
// //                     </td>
// //                   </tr>
// //                 ))
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ConsignorDashboard;

// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

// type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
// type PaymentMode = "paid" | "to_pay" | "credit";
// type FilterOption = "all" | ShipmentStatus;

// const API_BASE = process.env.REACT_APP_API_URL;

// interface APIConsignment {
//   id: number;
//   sender: number;
//   company: number;
//   receiver: number;
//   transporter: number;
//   driver: number;
//   vehicles: number;
//   payment: string;
//   source: string;
//   destination: string;
//   receiverAmountStatatus: string;
//   senderAmountStatatus: string;
//   transporterAmountStatatus: string;
//   paymentStatus: PaymentMode;
//   paymentPayableConsignor: number;
//   ItemsDescription: string;
//   ["InvoiceNo"]?: string;
//   ["InvoiceNo."]?: string;
//   EWAYBILLNO: string;
//   subjects: string;
//   link?: string;
//   status?: ShipmentStatus;
//   biltyNo?: string;
//   truckNo?: string;
//   created_at?: string;
//   weight?: number;
//   biltyRate?: number;
//   totalamount?: number;
//   consignorName?: string;
//   consigneeName?: string;
// }

// // Cache maps to avoid duplicate API calls for the same id
// const userCache: Record<number, string> = {};
// const vehicleCache: Record<number, string> = {};

// async function fetchUserName(id: number): Promise<string> {
//   if (userCache[id]) return userCache[id];
//   try {
//     const res = await fetch(`${API_BASE}/auth/user/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     const name = data.name || `User#${id}`;
//     userCache[id] = name;
//     return name;
//   } catch {
//     return `User#${id}`;
//   }
// }

// async function fetchVehicleNumber(id: number): Promise<string> {
//   if (vehicleCache[id]) return vehicleCache[id];
//   try {
//     const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
//     if (!res.ok) throw new Error();
//     const data = await res.json();
//     // registration_number is the truck plate number
//     const reg = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
//     vehicleCache[id] = reg;
//     return reg;
//   } catch {
//     return `Vehicle#${id}`;
//   }
// }

// const getInvoiceNo = (consignment: APIConsignment): string =>
//   consignment.InvoiceNo ||
//   //@ts-ignore
//   consignment["InvoiceNo."] ||
//   "";

// const getConsignmentStatus = (consignment: APIConsignment): ShipmentStatus => {
//   if (consignment.status) return consignment.status;
//   if (
//     consignment.paymentStatus === "to_pay" ||
//     consignment.paymentStatus === "credit"
//   )
//     return "pending";
//   if (consignment.paymentStatus === "paid") return "delivered";
//   return "pending";
// };

// const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
//   { key: "all", label: "All" },
//   { key: "pending", label: "Pending" },
//   { key: "in_transit", label: "In transit" },
//   { key: "delivered", label: "Delivered" },
//   { key: "draft", label: "Draft" },
// ];

// const STATUS_STYLES: Record<string, string> = {
//   pending: "bg-amber-100 text-amber-800",
//   in_transit: "bg-blue-100 text-blue-800",
//   delivered: "bg-green-100 text-green-800",
//   draft: "bg-slate-100 text-slate-500",
//   created: "bg-slate-100 text-slate-900",
//   dispatched: "bg-amber-100 text-amber-800",
//   cancelled: "bg-red-100 text-red-800",
// };

// const STATUS_LABELS: Record<string, string> = {
//   pending: "Pending",
//   in_transit: "In transit",
//   delivered: "Delivered",
//   draft: "Draft",
//   created: "Created",
//   dispatched: "Dispatched",
//   cancelled: "Cancelled",
// };

// const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
//   <span
//     className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
//       STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
//     }`}
//   >
//     {STATUS_LABELS[status] || status}
//   </span>
// );

// const DashboardStatCard: React.FC<{
//   label: string;
//   value: number;
//   color: string;
// }> = ({ label, value, color }) => (
//   <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
//     <span className="text-[26px] font-semibold mb-1" style={{ color }}>
//       {value}
//     </span>
//     <span className="text-xs font-medium text-slate-500">{label}</span>
//   </div>
// );

// const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({
//   consignment,
// }) => {
//   const link = consignment.link;
//   const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

//   const getDownloadUrl = () => {
//     if (!link) return "";
//     if (link.startsWith("http")) return link;
//     if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
//     return link;
//   };

//   const downloadUrl = getDownloadUrl();

//   const handleView = () => {
//     if (downloadUrl) window.open(downloadUrl, "_blank");
//   };

//   const handleDownload = () => {
//     if (downloadUrl) {
//       const a = document.createElement("a");
//       a.href = downloadUrl;
//       a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//     }
//   };

//   const handleShare = () => {
//     if (navigator.share && downloadUrl) {
//       navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
//     } else if (downloadUrl) {
//       navigator.clipboard.writeText(downloadUrl);
//       alert("Invoice link copied!");
//     }
//   };

//   if (!link) {
//     return <span className="text-slate-400 text-xs">No invoice</span>;
//   }

//   return (
//     <div className="flex items-center gap-2">
//       <button
//         className="hover:bg-slate-100 rounded p-1"
//         title="View Invoice"
//         onClick={handleView}
//       >
//         <FiEye className="w-4 h-4 text-blue-700" />
//       </button>
//       <button
//         className="hover:bg-slate-100 rounded p-1"
//         title="Download Invoice"
//         onClick={handleDownload}
//       >
//         <FiDownload className="w-4 h-4 text-green-700" />
//       </button>
//       <button
//         className="hover:bg-slate-100 rounded p-1"
//         title="Share Invoice"
//         onClick={handleShare}
//       >
//         <FiShare2 className="w-4 h-4 text-purple-600" />
//       </button>
//     </div>
//   );
// };

// const RowActions: React.FC<{
//   consignment: APIConsignment;
//   onEdit: (id: number) => void;
//   onDelete: (id: number) => void;
// }> = ({ consignment, onEdit, onDelete }) => (
//   <div className="flex items-center gap-2">
//     <button
//       className="hover:bg-slate-100 rounded p-1"
//       title="Edit"
//       onClick={() => onEdit(consignment.id)}
//     >
//       <FiEdit className="w-4 h-4 text-amber-600" />
//     </button>
//     <button
//       className="hover:bg-slate-100 rounded p-1"
//       title="Delete"
//       onClick={() => onDelete(consignment.id)}
//     >
//       <FiTrash className="w-4 h-4 text-red-700" />
//     </button>
//   </div>
// );

// // Resolved display names for a single row
// interface ResolvedNames {
//   consignorName: string;
//   consigneeName: string;
//   truckNo: string;
// }

// const ConsignorDashboard: React.FC = () => {
//   const [consignments, setConsignments] = useState<APIConsignment[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [activeFilter, setActiveFilter] = useState<FilterOption>("all");

//   // Map of consignment id → resolved names (populated asynchronously)
//   const [resolvedNames, setResolvedNames] = useState<
//     Record<number, ResolvedNames>
//   >({});

//   const navigate = useNavigate();

//   // After consignments load, resolve unique sender/receiver/vehicle ids
//   const resolveNames = useCallback(async (list: APIConsignment[]) => {
//     // Collect unique ids
//     const senderIds = [...new Set(list.map((c) => c.sender).filter(Boolean))];
//     const receiverIds = [...new Set(list.map((c) => c.receiver).filter(Boolean))];
//     const vehicleIds = [...new Set(list.map((c) => c.vehicles).filter(Boolean))];

//     // Fetch all in parallel
//     await Promise.all([
//       ...senderIds.map(fetchUserName),
//       ...receiverIds.map(fetchUserName),
//       ...vehicleIds.map(fetchVehicleNumber),
//     ]);

//     // Build per-consignment resolved names from the now-populated caches
//     const resolved: Record<number, ResolvedNames> = {};
//     for (const c of list) {
//       resolved[c.id] = {
//         consignorName: c.sender ? userCache[c.sender] || `User#${c.sender}` : "-",
//         consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}` : "-",
//         truckNo: c.vehicles
//           ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}`
//           : "-",
//       };
//     }
//     setResolvedNames(resolved);
//   }, []);

//   useEffect(() => {
//     setLoading(true);
//     setError(null);
//     fetch(`${API_BASE}/invoiceapi/invoice`)
//       .then((res) => res.json())
//       .then((data) => {
//         if (Array.isArray(data)) {
//           const mapped: APIConsignment[] = data.map((c: any) => {
//             const invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
//             return {
//               id: c.id,
//               sender: c.sender,
//               company: c.company,
//               receiver: c.receiver,
//               transporter: c.transporter,
//               driver: c.driver,
//               vehicles: c.vehicles,
//               payment: c.payment,
//               source: c.source,
//               destination: c.destination,
//               receiverAmountStatatus: c.receiverAmountStatatus,
//               senderAmountStatatus: c.senderAmountStatatus,
//               transporterAmountStatatus: c.transporterAmountStatatus,
//               paymentStatus: c.paymentStatus,
//               paymentPayableConsignor: c.paymentPayableConsignor,
//               ItemsDescription: c.ItemsDescription,
//               InvoiceNo: invoiceNo,
//               "InvoiceNo.": c["InvoiceNo."],
//               EWAYBILLNO: c.EWAYBILLNO,
//               subjects: c.subjects,
//               link: c.link ?? c.invoiceLink,
//               status: c.status ?? undefined,
//               biltyNo: c.biltyNo ?? invoiceNo,
//               created_at: c.created_at ?? "",
//               weight: c.weight ?? null,
//               biltyRate: c.biltyRate ?? null,
//               totalamount: c.totalamount ?? c.paymentPayableConsignor ?? null,
//             };
//           });
//           setConsignments(mapped);
//           resolveNames(mapped);
//         } else {
//           setConsignments([]);
//         }
//       })
//       .catch(() => setError("Unable to fetch consignments"))
//       .finally(() => setLoading(false));
//   }, [resolveNames]);

//   const filtered =
//     activeFilter === "all"
//       ? consignments
//       : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

//   const handleEdit = (id: number) =>
//     navigate(`/consignor/consignments/edit/${id}`);

//   const handleDelete = (id: number) => {
//     if (
//       !window.confirm(
//         "Are you sure you want to delete this consignment? This action cannot be undone."
//       )
//     )
//       return;
//     setConsignments((prev) => prev.filter((c) => c.id !== id));
//   };

//   const stats = [
//     { label: "Total", value: consignments.length, color: "#185FA5" },
//     {
//       label: "Pending",
//       value: consignments.filter((c) => getConsignmentStatus(c) === "pending")
//         .length,
//       color: "#854F0B",
//     },
//     {
//       label: "In transit",
//       value: consignments.filter(
//         (c) => getConsignmentStatus(c) === "in_transit"
//       ).length,
//       color: "#534AB7",
//     },
//     {
//       label: "Delivered",
//       value: consignments.filter(
//         (c) => getConsignmentStatus(c) === "delivered"
//       ).length,
//       color: "#3B6D11",
//     },
//   ];

//   return (
//     <div className="p-4 md:p-6 space-y-4">
//       {/* Stats */}
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
//         {stats.map((stat) => (
//           <DashboardStatCard key={stat.label} {...stat} />
//         ))}
//       </div>

//       {/* Panel / Table */}
//       <div className="bg-white border border-slate-100 rounded-2xl p-4">
//         {/* Header */}
//         <div className="flex items-center justify-between mb-3">
//           <div>
//             <h2 className="text-[16px] font-medium text-slate-900">
//               My Consignments
//             </h2>
//             <p className="text-xs text-slate-400">
//               View and manage your consignments &amp; invoices
//             </p>
//           </div>
//           <button
//             className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
//             onClick={() => navigate("/consignor/consignments/create")}
//           >
//             + New Consignment
//           </button>
//         </div>

//         {/* Filter Pills */}
//         <div className="flex flex-wrap gap-1.5 mb-4">
//           {FILTER_OPTIONS.map(({ key, label }) => (
//             <button
//               key={key}
//               onClick={() => setActiveFilter(key)}
//               className={`text-xs px-3 py-1 rounded-full border transition-colors ${
//                 activeFilter === key
//                   ? "bg-slate-900 text-white border-transparent"
//                   : "border-slate-200 text-slate-500 hover:bg-slate-50"
//               }`}
//             >
//               {label}
//             </button>
//           ))}
//         </div>

//         {/* Table */}
//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1100px] text-[13px]">
//             <thead>
//               <tr className="text-xs border-b border-slate-100">
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Date
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Bilty No.
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Truck No.
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Consignor
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Consignee
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Weight
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Bilty Rate
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Amount
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Status
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Invoice
//                 </th>
//                 <th className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td
//                     colSpan={11}
//                     className="py-6 text-center text-slate-400"
//                   >
//                     Loading...
//                   </td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan={11} className="py-6 text-center text-red-600">
//                     {error}
//                   </td>
//                 </tr>
//               ) : filtered.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan={11}
//                     className="py-8 text-center text-slate-400"
//                   >
//                     No consignments found.
//                   </td>
//                 </tr>
//               ) : (
//                 filtered.map((c) => {
//                   const names = resolvedNames[c.id];
//                   return (
//                     <tr
//                       key={c.id}
//                       className="border-b border-slate-100 hover:bg-slate-50 transition-all"
//                     >
//                       {/* Date */}
//                       <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
//                         {c.created_at
//                           ? new Date(c.created_at).toLocaleDateString()
//                           : "-"}
//                       </td>

//                       {/* Bilty No. */}
//                       <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
//                         {c.biltyNo || getInvoiceNo(c) || "-"}
//                       </td>

//                       {/* Truck No. — from vehicle API */}
//                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
//                         {names ? (
//                           names.truckNo
//                         ) : (
//                           <span className="text-slate-300 animate-pulse">
//                             Loading…
//                           </span>
//                         )}
//                       </td>

//                       {/* Consignor — from user API */}
//                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
//                         {names ? (
//                           names.consignorName
//                         ) : (
//                           <span className="text-slate-300 animate-pulse">
//                             Loading…
//                           </span>
//                         )}
//                       </td>

//                       {/* Consignee — from user API */}
//                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
//                         {names ? (
//                           names.consigneeName
//                         ) : (
//                           <span className="text-slate-300 animate-pulse">
//                             Loading…
//                           </span>
//                         )}
//                       </td>

//                       {/* Weight */}
//                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
//                         {c.weight != null ? c.weight : "-"}
//                       </td>

//                       {/* Bilty Rate */}
//                       <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
//                         {c.biltyRate != null ? c.biltyRate : "-"}
//                       </td>

//                       {/* Amount */}
//                       <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
//                         {c.totalamount != null
//                           ? c.totalamount
//                           : c.payment || "-"}
//                       </td>

//                       {/* Status */}
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         <StatusBadge status={getConsignmentStatus(c)} />
//                       </td>

//                       {/* Invoice */}
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         <InvoiceActions consignment={c} />
//                       </td>

//                       {/* Actions */}
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         <RowActions
//                           consignment={c}
//                           onEdit={handleEdit}
//                           onDelete={handleDelete}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ConsignorDashboard;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiDownload, FiShare2, FiEdit, FiTrash } from "react-icons/fi";

type ShipmentStatus = "pending" | "in_transit" | "delivered" | "draft";
type PaymentMode = "paid" | "to_pay" | "credit";
type FilterOption = "all" | ShipmentStatus;

const API_BASE = process.env.REACT_APP_API_URL;

interface APIConsignment {
  id: number;
  sender: number;
  company: number;
  receiver: number;
  transporter: number;
  driver: number;
  vehicles: number;
  payment: string;
  source: string;
  destination: string;
  receiverAmountStatatus: string;
  senderAmountStatatus: string;
  transporterAmountStatatus: string;
  paymentStatus: PaymentMode;
  paymentPayableConsignor: number;
  ItemsDescription: string;
  ["InvoiceNo"]?: string;
  ["InvoiceNo."]?: string;
  EWAYBILLNO: string;
  subjects: string;
  link?: string;
  status?: ShipmentStatus;
  biltyNo?: string;
  created_at?: string;
  totalamount?: number;
  // resolved after load
  consignorName?: string;
  consigneeName?: string;
  truckNo?: string;
  // computed from invoice_items
  totalWeight?: number | null;   // sum of qty across all items
  biltyRate?: number | null;     // amount / qty (per item, or total amount / total qty)
  totalItemAmount?: number | null; // sum of amount across all items
}

interface InvoiceItem {
  id: number;
  invoiceId: string;
  description: string;
  hsm_code: string;
  uom: string;
  qty: number;
  amount: number;
}

// ─── Caches ───────────────────────────────────────────────────────────────────
const userCache: Record<number, string> = {};
const vehicleCache: Record<number, string> = {};
const itemsCache: Record<string, InvoiceItem[]> = {};

async function fetchUserName(id: number): Promise<string> {
  if (userCache[id]) return userCache[id];
  try {
    const res = await fetch(`${API_BASE}/auth/user/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    const name = data.name || `User#${id}`;
    userCache[id] = name;
    return name;
  } catch {
    userCache[id] = `User#${id}`;
    return userCache[id];
  }
}

async function fetchVehicleNumber(id: number): Promise<string> {
  if (vehicleCache[id]) return vehicleCache[id];
  try {
    const res = await fetch(`${API_BASE}/auth/vehicles/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    const reg = data.registration_number || data.vehicle_number || `Vehicle#${id}`;
    vehicleCache[id] = reg;
    return reg;
  } catch {
    vehicleCache[id] = `Vehicle#${id}`;
    return vehicleCache[id];
  }
}

async function fetchInvoiceItems(invoiceDbId: string): Promise<InvoiceItem[]> {
  if (itemsCache[invoiceDbId]) return itemsCache[invoiceDbId];
  try {
    const res = await fetch(
      `${API_BASE}/invoiceapi/invoice_items/invoice-db/${invoiceDbId}`
    );
    if (!res.ok) throw new Error();
    const data: InvoiceItem[] = await res.json();
    itemsCache[invoiceDbId] = Array.isArray(data) ? data : [];
    return itemsCache[invoiceDbId];
  } catch {
    itemsCache[invoiceDbId] = [];
    return [];
  }
}

// ─── Derived helpers ──────────────────────────────────────────────────────────

/**
 * Given a list of items for one invoice:
 *   totalWeight = sum of qty
 *   totalAmount = sum of amount
 *   biltyRate   = totalAmount / totalWeight  (rate per unit)
 */
function computeItemStats(items: InvoiceItem[]) {
  if (!items.length) return { totalWeight: null, biltyRate: null, totalItemAmount: null };
  const totalWeight = items.reduce((sum, i) => sum + Number(i.qty || 0), 0);
  const totalAmount = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const biltyRate = totalWeight > 0 ? totalAmount / totalWeight : null;
  return {
    totalWeight,
    biltyRate: biltyRate !== null ? Math.round(biltyRate * 100) / 100 : null,
    totalItemAmount: totalAmount,
  };
}

// ─── Formatting ───────────────────────────────────────────────────────────────
function fmt(val: number | null | undefined, decimals = 2): string {
  if (val == null) return "-";
  return val % 1 === 0 ? String(val) : val.toFixed(decimals);
}

// ─── Status helpers ───────────────────────────────────────────────────────────
const getInvoiceNo = (c: APIConsignment): string =>
  c.InvoiceNo || (c as any)["InvoiceNo."] || "";

const getConsignmentStatus = (c: APIConsignment): ShipmentStatus => {
  if (c.status) return c.status;
  if (c.paymentStatus === "to_pay" || c.paymentStatus === "credit") return "pending";
  if (c.paymentStatus === "paid") return "delivered";
  return "pending";
};

// ─── Constants ────────────────────────────────────────────────────────────────
const FILTER_OPTIONS: { key: FilterOption; label: string }[] = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "in_transit", label: "In transit" },
  { key: "delivered", label: "Delivered" },
  { key: "draft", label: "Draft" },
];

const STATUS_STYLES: Record<string, string> = {
  pending: "bg-amber-100 text-amber-800",
  in_transit: "bg-blue-100 text-blue-800",
  delivered: "bg-green-100 text-green-800",
  draft: "bg-slate-100 text-slate-500",
  created: "bg-slate-100 text-slate-900",
  dispatched: "bg-amber-100 text-amber-800",
  cancelled: "bg-red-100 text-red-800",
};

const STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  in_transit: "In transit",
  delivered: "Delivered",
  draft: "Draft",
  created: "Created",
  dispatched: "Dispatched",
  cancelled: "Cancelled",
};

// ─── Small components ─────────────────────────────────────────────────────────
const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span
    className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
      STATUS_STYLES[status] || "bg-slate-100 text-slate-900"
    }`}
  >
    {STATUS_LABELS[status] || status}
  </span>
);

const DashboardStatCard: React.FC<{
  label: string;
  value: number;
  color: string;
}> = ({ label, value, color }) => (
  <div className="rounded-xl bg-slate-50 p-4 flex flex-col justify-center items-center">
    <span className="text-[26px] font-semibold mb-1" style={{ color }}>
      {value}
    </span>
    <span className="text-xs font-medium text-slate-500">{label}</span>
  </div>
);

const LoadingCell = () => (
  <span className="text-slate-300 animate-pulse text-xs">Loading…</span>
);

const InvoiceActions: React.FC<{ consignment: APIConsignment }> = ({ consignment }) => {
  const link = consignment.link;
  const invoiceLabel = getInvoiceNo(consignment) || consignment.EWAYBILLNO || "";

  const getDownloadUrl = () => {
    if (!link) return "";
    if (link.startsWith("http")) return link;
    if (API_BASE && link.startsWith("/")) return `${API_BASE}${link}`;
    return link;
  };
  const downloadUrl = getDownloadUrl();

  const handleView = () => { if (downloadUrl) window.open(downloadUrl, "_blank"); };
  const handleDownload = () => {
    if (!downloadUrl) return;
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = invoiceLabel ? `Invoice_${invoiceLabel}` : "Invoice";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handleShare = () => {
    if (navigator.share && downloadUrl) {
      navigator.share({ title: `Invoice ${invoiceLabel}`, url: downloadUrl });
    } else if (downloadUrl) {
      navigator.clipboard.writeText(downloadUrl);
      alert("Invoice link copied!");
    }
  };

  if (!link) return <span className="text-slate-400 text-xs">No invoice</span>;

  return (
    <div className="flex items-center gap-2">
      <button className="hover:bg-slate-100 rounded p-1" title="View Invoice" onClick={handleView}>
        <FiEye className="w-4 h-4 text-blue-700" />
      </button>
      <button className="hover:bg-slate-100 rounded p-1" title="Download Invoice" onClick={handleDownload}>
        <FiDownload className="w-4 h-4 text-green-700" />
      </button>
      <button className="hover:bg-slate-100 rounded p-1" title="Share Invoice" onClick={handleShare}>
        <FiShare2 className="w-4 h-4 text-purple-600" />
      </button>
    </div>
  );
};

const RowActions: React.FC<{
  consignment: APIConsignment;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}> = ({ consignment, onEdit, onDelete }) => (
  <div className="flex items-center gap-2">
    <button className="hover:bg-slate-100 rounded p-1" title="Edit" onClick={() => window.location.href=`/admin/edit/consignments/${consignment.id}`}>
      <FiEdit className="w-4 h-4 text-amber-600" />
    </button>
    <button className="hover:bg-slate-100 rounded p-1" title="Delete" onClick={() => onDelete(consignment.id)}>
      <FiTrash className="w-4 h-4 text-red-700" />
    </button>
  </div>
);

// ─── Resolved per-row data ────────────────────────────────────────────────────
interface ResolvedRow {
  consignorName: string;
  consigneeName: string;
  truckNo: string;
  companyName: string;          // ← add this
  totalWeight: number | null;
  biltyRate: number | null;
  totalItemAmount: number | null;
}

// ─── Main component ───────────────────────────────────────────────────────────
const ConsignorDashboard: React.FC = () => {
  const [consignments, setConsignments] = useState<APIConsignment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [activeFilter, setActiveFilter] = useState<FilterOption>("all");
  const [resolvedRows, setResolvedRows] = useState<Record<number, ResolvedRow>>({});
  const companyCache: Record<number, string> = {};

async function fetchCompanyName(id: number): Promise<string> {
  if (companyCache[id]) return companyCache[id];
  try {
    const res = await fetch(`${API_BASE}/companyauth/company/${id}`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    const name = data.name || data.company_name || `Company#${id}`;
    companyCache[id] = name;
    return name;
  } catch {
    companyCache[id] = `Company#${id}`;
    return companyCache[id];
  }
}
  const navigate = useNavigate();

  const resolveRows = useCallback(async (list: APIConsignment[]) => {
    // Unique ids to avoid redundant fetches
    const senderIds  = [...new Set(list.map((c) => c.sender).filter(Boolean))];
    const receiverIds = [...new Set(list.map((c) => c.receiver).filter(Boolean))];
    const vehicleIds  = [...new Set(list.map((c) => c.vehicles).filter(Boolean))];
    const invoiceNos  = [...new Set(list.map(getInvoiceNo).filter(Boolean))];

    // Fetch everything in parallel
    await Promise.all([
      ...senderIds.map(fetchUserName),
      ...receiverIds.map(fetchUserName),
      ...vehicleIds.map(fetchVehicleNumber),
      ...invoiceNos.map(fetchInvoiceItems),
    ]);

    // Build resolved map
    const resolved: Record<number, ResolvedRow> = {};
    for (const c of list) {
      const invoiceNo = getInvoiceNo(c);
      const items = invoiceNo ? itemsCache[invoiceNo] ?? [] : [];
      const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);

      resolved[c.id] = {
        consignorName: c.sender  ? userCache[c.sender]   || `User#${c.sender}`       : "-",
        consigneeName: c.receiver ? userCache[c.receiver] || `User#${c.receiver}`     : "-",
        truckNo:       c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}` : "-",
        companyName:   c.company  ? companyCache[c.company]  || `Company#${c.company}`    : "-",  // ← add
        totalWeight,
        biltyRate,
        totalItemAmount,
      };
    }
    setResolvedRows(resolved);
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);
  
    fetch(`${API_BASE}/invoiceapi/invoice`)
      .then((res) => res.json())
      .then(async (data) => {
        if (!Array.isArray(data)) { setConsignments([]); return; }
  
        // 1. Map raw API shape first (sync, no fetching yet)
        const mapped: APIConsignment[] = data.map((c: any) => {
          const invoiceNo = c["InvoiceNo"] ?? c["InvoiceNo."] ?? "";
          return {
            id: c.id,
            sender: c.sender,
            company: c.company,
            receiver: c.receiver,
            transporter: c.transporter,
            driver: c.driver,
            vehicles: c.vehicles,
            payment: c.payment,
            source: c.source,
            destination: c.destination,
            receiverAmountStatatus: c.receiverAmountStatatus,
            senderAmountStatatus: c.senderAmountStatatus,
            transporterAmountStatatus: c.transporterAmountStatatus,
            paymentStatus: c.paymentStatus,
            paymentPayableConsignor: c.paymentPayableConsignor,
            ItemsDescription: c.ItemsDescription,
            InvoiceNo: invoiceNo,
            "InvoiceNo.": c["InvoiceNo."],
            EWAYBILLNO: c.EWAYBILLNO,
            subjects: c.subjects,
            link: c.link ?? c.invoiceLink,
            status: c.status ?? undefined,
            biltyNo: c.biltyNo ?? invoiceNo,
            created_at: c.created_at ?? "",
            totalamount: c.totalamount ?? null,
          };
        });
  
        // 2. Collect unique IDs/keys to avoid redundant fetches
        const senderIds   = [...new Set(mapped.map((c) => c.sender).filter(Boolean))];
        const receiverIds = [...new Set(mapped.map((c) => c.receiver).filter(Boolean))];
        const vehicleIds  = [...new Set(mapped.map((c) => c.vehicles).filter(Boolean))];
        const invoiceNos  = [...new Set(mapped.map(getInvoiceNo).filter(Boolean))];
        const invoiceDbIds = [...new Set(mapped.map(c => String(c.id)).filter(Boolean))];

  
        // 3. Fire ALL lookups in parallel before touching state.
        //    allSettled means one bad fetch won't kill the rest.
        const companyIds = [...new Set(mapped.map((c) => c.company).filter(Boolean))];

        await Promise.allSettled([
          ...senderIds.map(fetchUserName),
          ...receiverIds.map(fetchUserName),
          ...vehicleIds.map(fetchVehicleNumber),
          ...companyIds.map(fetchCompanyName), 
          ...invoiceDbIds.map(fetchInvoiceItems),

        ]);
  
        // 4. Build resolved map from now-populated caches
        const resolved: Record<number, ResolvedRow> = {};
        for (const c of mapped) {
          const items = itemsCache[String(c.id)] ?? [];
          const { totalWeight, biltyRate, totalItemAmount } = computeItemStats(items);
          resolved[c.id] = {
            consignorName: c.sender   ? userCache[c.sender]      || `User#${c.sender}`        : "-",
            consigneeName: c.receiver ? userCache[c.receiver]    || `User#${c.receiver}`      : "-",
            truckNo:       c.vehicles ? vehicleCache[c.vehicles] || `Vehicle#${c.vehicles}`   : "-",
            companyName:   c.company  ? companyCache[c.company]  || `Company#${c.company}`    : "-",  // ← add
            totalWeight,
            biltyRate,
            totalItemAmount,
          };
        }
  
        // 5. Single state update → single render, no flicker
        setResolvedRows(resolved);
        setConsignments(mapped);
      })
      .catch(() => setError("Unable to fetch consignments"))
      .finally(() => setLoading(false));
  }, []); // no resolveRows dependency needed anymore

  const filtered =
    activeFilter === "all"
      ? consignments
      : consignments.filter((c) => getConsignmentStatus(c) === activeFilter);

  const handleEdit   = (id: number) => navigate(`/consignor/consignments/edit/${id}`);
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this consignment? This action cannot be undone.")) return;

    try {
      const res = await fetch(`${API_BASE}/invoiceapi/invoice/${id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        setConsignments((prev) => prev.filter((c) => c.id !== id));
      } else if (res.status === 404) {
        alert("Consignment not found (already deleted).");
        setConsignments((prev) => prev.filter((c) => c.id !== id));
      } else {
        const err = await res.json();
        alert(`Failed to delete consignment: ${err.error || "Unknown error"}`);
      }
    } catch (error: any) {
      alert(`Failed to delete consignment: ${error?.message || error}`);
    }
  };

  const stats = [
    { label: "Total",      value: consignments.length,                                                         color: "#185FA5" },
    { label: "Pending",    value: consignments.filter((c) => getConsignmentStatus(c) === "pending").length,    color: "#854F0B" },
    { label: "In transit", value: consignments.filter((c) => getConsignmentStatus(c) === "in_transit").length, color: "#534AB7" },
    { label: "Delivered",  value: consignments.filter((c) => getConsignmentStatus(c) === "delivered").length,  color: "#3B6D11" },
  ];

  return (
    <div className="p-4 md:p-6 space-y-4">
      {/* Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {stats.map((stat) => (
          <DashboardStatCard key={stat.label} {...stat} />
        ))}
      </div>

      {/* Panel */}
      <div className="bg-white border border-slate-100 rounded-2xl p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="text-[16px] font-medium text-slate-900">My Consignments</h2>
            <p className="text-xs text-slate-400">View and manage your consignments &amp; invoices</p>
          </div>
          <button
            className="text-xs px-3 py-1 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"
            onClick={() => navigate("/consignor/consignments/create")}
          >
            + New Consignment
          </button>
        </div>

        {/* Filter pills */}
        <div className="flex flex-wrap gap-1.5 mb-4">
          {FILTER_OPTIONS.map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setActiveFilter(key)}
              className={`text-xs px-3 py-1 rounded-full border transition-colors ${
                activeFilter === key
                  ? "bg-slate-900 text-white border-transparent"
                  : "border-slate-200 text-slate-500 hover:bg-slate-50"
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1100px] text-[13px]">
            <thead>
              <tr className="text-xs border-b border-slate-100">
                {[
                  "Date",
                  "Company", 
                  "Bilty No.",
                  "Truck No.",
                  "Consignor",
                  "Consignee",
                  "Weight (qty)",
                  "Bilty Rate (amt/qty)",
                  "Amount",
                  "Status",
                  "Invoice",
                  "Actions",
                ].map((h) => (
                  <th key={h} className="py-2 px-3 font-semibold text-slate-500 text-left whitespace-nowrap">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={11} className="py-6 text-center text-slate-400">Loading...</td></tr>
              ) : error ? (
                <tr><td colSpan={11} className="py-6 text-center text-red-600">{error}</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={11} className="py-8 text-center text-slate-400">No consignments found.</td></tr>
              ) : (
                filtered.map((c) => {
                  const row = resolvedRows[c.id];
                  return (
                    <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50 transition-all">
                      {/* Date */}
                      <td className="py-2 px-3 text-slate-500 text-xs whitespace-nowrap">
                        {c.created_at ? new Date(c.created_at).toLocaleDateString() : "-"}
                      </td>
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
  {row ? row.companyName : <LoadingCell />}
</td>

                      {/* Bilty No. */}
                      <td className="py-2 px-3 text-slate-900 font-medium whitespace-nowrap">
                        {c.biltyNo || getInvoiceNo(c) || "-"}
                      </td>

                      {/* Truck No. */}
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
                        {row ? row.truckNo : <LoadingCell />}
                      </td>

                      {/* Consignor */}
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
                        {row ? row.consignorName : <LoadingCell />}
                      </td>

                      {/* Consignee */}
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
                        {row ? row.consigneeName : <LoadingCell />}
                      </td>

                      {/* Weight = sum of qty from invoice_items */}
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
                        {row ? fmt(row.totalWeight) : <LoadingCell />}
                   
                      </td>

                      {/* Bilty Rate = totalAmount / totalWeight */}
                      <td className="py-2 px-3 text-slate-700 whitespace-nowrap">
                        {row ? fmt(row.biltyRate) : <LoadingCell />}
                      </td>

                      {/* Amount = sum of amount from invoice_items (fallback to payment field) */}
                      <td className="py-2 px-3 text-slate-700 font-medium whitespace-nowrap">
                        {row
                          ? row.totalItemAmount != null
                            ? fmt(row.totalItemAmount, 0)
                            : c.totalamount != null
                            ? fmt(c.totalamount, 0)
                            : c.payment || "-"
                          : <LoadingCell />}
                      </td>

                      {/* Status */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        <StatusBadge status={getConsignmentStatus(c)} />
                      </td>

                      {/* Invoice */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        <InvoiceActions consignment={c} />
                      </td>

                      {/* Actions */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        <RowActions consignment={c} onEdit={handleEdit} onDelete={handleDelete} />
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ConsignorDashboard;